import "./App.css";
import LoadMore from "./LoadMore/LoadMore";

function App() {
  return (
    <div className="App">
      <LoadMore />
    </div>
  );
}

export default App;
